import { doc, setDoc, getDoc, getFirestore } from "firebase/firestore";
import app from "./firebase.config";

const db = getFirestore(app);

function simpleHash(str) {
  const normalized = str.toLowerCase().trim();
  let hash = 0;
  for (let i = 0; i < normalized.length; i++) {
    hash = (hash << 5) - hash + normalized.charCodeAt(i);
    hash |= 0; // Convert to 32-bit integer
  }
  return hash;
}

export const addEmailToList = async (userData) => {
  // Extract email from userData object
  const { email, name, device, timestamp } = userData;
  
  // Basic email validation
  if (!email || !email.includes("@") || !email.includes(".")) {
    return {
      success: false,
      message: "That didn't quite work. Try again."
    };
  }
  
  const emailHash = simpleHash(email);
  const signupDoc = doc(db, "betaSignups", emailHash.toString());
  
  try {
    // Check if this email hash already exists
    const docSnapshot = await getDoc(signupDoc);
    if (docSnapshot.exists()) {
      return {
        success: false,
        message: "You're already on the list."
      };
    }
    
    // Create new document with the user data as direct fields
    await setDoc(signupDoc, {
      email: email,
      name: name,
      device: device,
      signupDate: timestamp
    });
    
    return {
      success: true,
      message: "Great. We'll let you know if you're invited to test Lift Coach AI."
    };
  } catch (error) {
    console.error("Email signup error:", error);
    return {
      success: false,
      message: error.message
    };
  }
};